import * as actions from './actions';

export default function(state = null, action) {
  switch (action.type) {

  case actions.SET_STATUS:
    return action.status;

  default:
    return state;
  }
}
